function NRUserIcon({ height = '20', width = '20', color = 'currentColor' }) {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.66671 6.66665C6.66671 4.82498 8.15837 3.33331 10 3.33331C11.8417 3.33331 13.3334 4.82498 13.3334 6.66665C13.3334 8.50831 11.8417 9.99998 10 9.99998C8.15837 9.99998 6.66671 8.50831 6.66671 6.66665ZM11.6667 6.66665C11.6667 5.74998 10.9167 4.99998 10 4.99998C9.08337 4.99998 8.33337 5.74998 8.33337 6.66665C8.33337 7.58331 9.08337 8.33331 10 8.33331C10.9167 8.33331 11.6667 7.58331 11.6667 6.66665Z"
        fill={color}
      />
      <path
        d="M7.08337 11.6666C6.1513 11.6666 5.22603 11.947 4.51594 12.488C3.8011 13.0326 3.33337 13.8273 3.33337 14.7222V15.8333C3.33337 16.2935 3.70647 16.6666 4.16671 16.6666C4.62694 16.6666 5.00004 16.2935 5.00004 15.8333V14.7222C5.00004 14.4383 5.1469 14.1026 5.52602 13.8137C5.90989 13.5212 6.46835 13.3333 7.08337 13.3333H12.9167C13.5317 13.3333 14.0902 13.5212 14.4741 13.8137C14.8532 14.1026 15 14.4383 15 14.7222V15.8333C15 16.2935 15.3731 16.6666 15.8334 16.6666C16.2936 16.6666 16.6667 16.2935 16.6667 15.8333V14.7222C16.6667 13.8273 16.199 13.0326 15.4841 12.488C14.7741 11.947 13.8488 11.6666 12.9167 11.6666H7.08337Z"
        fill={color}
      />
    </svg>
  );
}

export default NRUserIcon;
